const VAT = 18;

export default VAT;
